import { useLang } from "../context/LanguageContext";
import { useData } from "../context/DataContext";

export default function Contact() {
  const { t } = useLang();
  const { profile } = useData();
  const mailto = `mailto:${profile.email.replace("[at]", "@")}`;

  return (
    <section id="contact" className="section section--contact">
      <div className="section__header">
        <h2 className="section__title">{t.nav.contact}</h2>
      </div>

      <p className="contact__note">{t.contact.note}</p>

      <a href={mailto} className="contact__email">
        <span className="contact__email-label">{t.contact.label}</span>
        <span className="contact__email-value">{profile.email}</span>
        <span aria-hidden="true" className="contact__email-arrow">
          ↗
        </span>
      </a>
    </section>
  );
}
